import React, { useEffect } from 'react';
import Toast from './Toast';
import { useToast } from '../../context/ToastContext';

const ToastContainer = () => {
  const { toasts, removeToast, clearAllToasts } = useToast();

  // ESC 關最新一則、Shift+ESC 一次清空整個堆疊，堆疊 ≥2 時另給滑鼠使用者
  // 「全部關閉（N）」按鈕。這三項原是 RENT-34 舊政策（提醒不會自己消失）時期的配套。
  // BIGLI-24 改為每則 5 秒自動消失後，PM Bridget（2026-08-26）確認三項一併保留：
  // 一次跳很多則時，使用者仍會想立刻清掉而不是等 5 秒，所以留著仍然有用。
  useEffect(() => {
    if (toasts.length === 0) return undefined;
    const handleKeyDown = (event) => {
      if (event.key !== 'Escape') return;
      if (event.shiftKey) {
        clearAllToasts();
        return;
      }
      const latest = toasts[toasts.length - 1];
      if (latest) removeToast(latest.id);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [toasts, removeToast, clearAllToasts]);

  return (
    <div
      className="toast-container"
      role="region"
      aria-live="polite"
      aria-label="系統提醒區"
    >
      {toasts.length >= 2 && (
        <button
          type="button"
          className="toast-clear-all"
          onClick={clearAllToasts}
          aria-label={`一次關閉全部 ${toasts.length} 則提醒`}
          title="全部關閉（Shift + Esc）"
        >
          全部關閉（{toasts.length}）
        </button>
      )}
      {/*
        onClose 直接傳 context 的 removeToast（useCallback 包過、identity 穩定），
        不要寫成 onClose={() => removeToast(toast.id)}——那個 inline arrow 每次
        render 都是新函式，會讓 Toast 內的 5 秒計時器每次 render 都重新起算。
        id 由 Toast 自己在呼叫時帶回去。
      */}
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={removeToast}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
